"use client";
import { Provider, createStore } from "jotai";
import { ReactFlowProvider } from "@xyflow/react";
import {
  Account,
  BuiltInApp,
  RawCanvas,
  Session,
  Toggles,
} from "@zapier/canvas-state";
import { CurrentAccountIdProvider } from "@zapier/identity";

import { Canvas } from "../components/Canvas";
import { CanvasHydrator } from "../components/CanvasHydrator";
import { CanvasBackground } from "../components/CanvasBackground";
import { BuilderNav } from "../components/BuilderNav";
import { ExecuteAiPrompt } from "../components/ExecuteAiPrompt";
import { CanvasComposerHydrator } from "../components/CanvasComposer";

const store = createStore();

type Props = {
  canvas: RawCanvas;
  chatbotsApp: BuiltInApp;
  tablesApp: BuiltInApp;
  interfacesApp: BuiltInApp;
  session?: Session;
  account?: Account;
  toggles: Toggles;
  prompt: string;
};

export function AiPage({
  canvas,
  chatbotsApp,
  tablesApp,
  interfacesApp,
  toggles,
  account,
  session,
  prompt,
}: Props) {
  return (
    <CurrentAccountIdProvider>
      <ReactFlowProvider>
        <Provider store={store}>
          <CanvasComposerHydrator>
            <CanvasHydrator
              canvas={canvas}
              chatbotsApp={chatbotsApp}
              tablesApp={tablesApp}
              interfacesApp={interfacesApp}
              toggles={toggles}
              account={account}
              session={session}
              prompt={prompt}
              showAIStreamCreateModal={!toggles.streamingUi}
              isAiPage={true}
            >
              <ExecuteAiPrompt prompt={prompt} />
              <BuilderNav>
                <Canvas>
                  <CanvasBackground />
                </Canvas>
              </BuilderNav>
            </CanvasHydrator>
          </CanvasComposerHydrator>
        </Provider>
      </ReactFlowProvider>
    </CurrentAccountIdProvider>
  );
}
